(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cards-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('collection-cards-slider')) return;

    class CollectionCardsSlider extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');
        this.tabButtons = Array.from(this.querySelectorAll('[data-tab]'));
        this.cards = Array.from(this.querySelectorAll('[data-card]'));

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.track?.classList.remove(
          'is-dragging',
          'is-scrollbar-dragging',
          'is-free-scrolling',
          'is-programmatic-scrolling'
        );
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const tabButton = event.target.closest('[data-tab]');
        if (tabButton && this.contains(tabButton)) {
          this.activateTab(tabButton);
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollCards(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) this.scrollCards(1);
      }

      onResize() {
        this.updateScrollable();
      }

      onScroll() {
        this.updateControls();
      }

      activateTab(tabButton) {
        const filter = tabButton.dataset.filter;

        this.tabButtons.forEach((button) => {
          const isActive = button === tabButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.cards.forEach((card) => {
          const tags = (card.dataset.tags || '').split(/\s+/).filter(Boolean);
          card.hidden = filter !== 'all' && tags.length > 0 && !tags.includes(filter);
        });

        if (this.track) {
          this.cancelScrollAnimation();
          this.track.classList.add('is-programmatic-scrolling');
          this.track.scrollLeft = 0;
          window.requestAnimationFrame(() => {
            this.track.classList.remove('is-programmatic-scrolling');
          });
        }

        this.updateScrollable();
        this.dispatchEvent(new CustomEvent('collection-cards-slider:tab-change', {
          bubbles: true,
          detail: { filter }
        }));
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--collection-cards-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX, true);
      }

      scrollToScrollbarPosition(clientX, animate = false) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--collection-cards-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        if (animate) {
          this.animateScrollTo(maxScroll * progress, 400, true);
          return;
        }

        // Dragging: lock the track to the thumb instead of restarting the eased scroll on every move
        this.cancelScrollAnimation();
        this.scrollbar.value = String(progress * 100);
        this.track.scrollLeft = maxScroll * progress;
        this.updateControls();
      }

      scrollCards(direction) {
        if (!this.track) return;

        const cards = this.cards.filter((card) => !card.hidden);
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const track = event.target.closest('[data-track]');
        if (!track || !this.contains(track) || track.scrollWidth <= track.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activePointerId = event.pointerId;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = track.scrollLeft;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.track || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.track.setPointerCapture(event.pointerId);
          this.track.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.track || event.pointerId !== this.activePointerId) return;

        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-track]')) event.preventDefault();
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (this.controls) this.controls.hidden = !isScrollable;
          this.updateControls();
        });
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling && this.scrollbarPointerId == null) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }
    }

    customElements.define('collection-cards-slider', CollectionCardsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-menu"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-menu')) return;

    class CollectionMenu extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        this.activeItem = this.querySelector('[data-active]')?.closest('[data-item]');
        window.addEventListener('resize', this.onResize);
        this.addEventListener('click', this.onClick);
        this.revealActive();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.removeEventListener('click', this.onClick);
        window.clearTimeout(this.resizeTimer);
      }

      // Navigation itself is left to the browser; the underline moves to the clicked item right away.
      onClick(event) {
        const link = event.target.closest('[data-link]');
        if (!link || link.classList.contains('is-active')) return;
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        this.querySelectorAll('[data-link].is-active').forEach((active) => active.classList.remove('is-active'));
        link.classList.add('is-active');
      }

      onResize() {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.revealActive(), 150);
      }

      // On narrow screens the list scrolls sideways: bring the active item into view.
      revealActive() {
        const scroller = this.scroller;
        const item = this.activeItem;
        if (!scroller || !item || scroller.scrollWidth <= scroller.clientWidth) return;
        const padding = parseFloat(getComputedStyle(item.parentElement).paddingLeft) || 0;
        // The scroller is the offset parent, so offsetLeft does not depend on its scroll position.
        const start = item.offsetLeft;
        const end = start + item.offsetWidth;
        if (start - padding >= scroller.scrollLeft && end + padding <= scroller.scrollLeft + scroller.clientWidth) return;
        scroller.scrollLeft = Math.max(start - padding, 0);
      }
    }

    customElements.define('collection-menu', CollectionMenu);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-select-product-grid"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-product-tabs')) return;

    class CollectionProductTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onGridChange = this.onGridChange.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-tabs]');
        this.section = this.closest('[data-collection-grid]');
        this.gridContainer = this.section?.querySelector('[data-product-grid-container]');
        this.activeFilter = 'all';

        this.addEventListener('click', this.onClick);
        this.track?.addEventListener('pointerdown', this.onPointerDown);
        this.track?.addEventListener('dragstart', this.onDragStart);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.tabsResizeObserver = new ResizeObserver(this.onResize);
        if (this.track) this.tabsResizeObserver.observe(this.track);

        if (this.gridContainer) {
          this.gridObserver = new MutationObserver(this.onGridChange);
          this.gridObserver.observe(this.gridContainer, { childList: true, subtree: true });
        }

        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('pointerdown', this.onPointerDown);
        this.track?.removeEventListener('dragstart', this.onDragStart);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        this.tabsResizeObserver?.disconnect();
        this.gridObserver?.disconnect();
        window.clearTimeout(this.clickResetTimer);
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          this.suppressClick = false;
          return;
        }

        const tab = event.target.closest('[data-tab]');
        if (!tab || !this.contains(tab)) return;

        this.querySelectorAll('[data-tab]').forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', String(isActive));
        });

        this.activeFilter = tab.dataset.filter;
        this.filterProducts();
      }

      onResize() {
        this.updateScrollable();
      }

      onGridChange() {
        this.filterProducts();
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch' || !this.track?.classList.contains('is-scrollable')) return;

        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = this.track.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) this.track.setPointerCapture(event.pointerId);
        this.hasDragged = true;
        this.track.classList.add('is-dragging');
        this.track.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId !== this.activePointerId) return;

        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      filterProducts() {
        const cards = this.section?.querySelectorAll('[data-product-card]') || [];
        let visibleCount = 0;

        cards.forEach((card) => {
          const isVisible = this.activeFilter === 'all' || card.dataset.productTitle.includes(this.activeFilter);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        const emptyMessage = this.section?.querySelector('[data-tabs-empty]');
        if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (!isScrollable) this.track.scrollLeft = 0;
        });
      }
    }

    customElements.define('collection-product-tabs', CollectionProductTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('customer-reviews')) return;

    class CustomerReviews extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.updateLayout();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateLayout();
        });
        this.observeOffscreenImages();
      }

      // Lazy images clipped by the horizontal track are not loaded by every engine until they
      // scroll into the track, so cards revealed by the centred start or a swipe stay blank.
      // Load them all once the section approaches the viewport.
      observeOffscreenImages() {
        if (!this.hasAttribute('data-preload-offscreen') || !this.track) return;

        const images = [...this.track.querySelectorAll('img[loading="lazy"]')];
        if (!images.length) return;

        const loadImages = () => images.forEach((image) => (image.loading = 'eager'));
        if (!('IntersectionObserver' in window)) {
          loadImages();
          return;
        }

        this.imageObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            loadImages();
            this.imageObserver.disconnect();
          },
          { rootMargin: '600px 0px' }
        );
        this.imageObserver.observe(this);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        this.imageObserver?.disconnect();
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.activeScroller?.classList.remove('is-dragging');
        this.track?.classList.remove('is-scrollbar-dragging', 'is-free-scrolling', 'is-programmatic-scrolling');
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const readMoreButton = event.target.closest('[data-read-more]');
        if (readMoreButton && this.contains(readMoreButton)) {
          this.toggleReview(readMoreButton);
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollReviews(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) this.scrollReviews(1);
      }

      onResize() {
        this.updateLayout();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--customer-reviews-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX, true);
      }

      scrollToScrollbarPosition(clientX, animate = false) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--customer-reviews-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        if (animate) {
          this.animateScrollTo(maxScroll * progress, 400, true);
          return;
        }

        // Dragging: lock the track to the thumb instead of restarting the eased scroll on every move
        this.cancelScrollAnimation();
        this.scrollbar.value = String(progress * 100);
        this.track.scrollLeft = maxScroll * progress;
        this.updateControls();
      }

      scrollReviews(direction) {
        if (!this.track) return;

        const cards = Array.from(this.track.querySelectorAll('[data-card]'));
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const scroller = event.target.closest('[data-scroll]');
        if (!scroller || !this.contains(scroller) || scroller.scrollWidth <= scroller.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activeScroller = scroller;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = scroller.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.activeScroller.setPointerCapture(event.pointerId);
          this.activeScroller.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.activeScroller.classList.add('is-dragging');
        this.activeScroller.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        if (this.activeScroller.hasPointerCapture(event.pointerId)) {
          this.activeScroller.releasePointerCapture(event.pointerId);
        }

        this.activeScroller.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activeScroller = null;
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      toggleReview(button) {
        const review = button.closest('[data-review]');
        if (!review) return;

        const isExpanded = review.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(isExpanded));
        button.textContent = isExpanded ? button.dataset.lessLabel : button.dataset.moreLabel;
        this.dispatchEvent(new CustomEvent('customer-reviews:toggle', {
          bubbles: true,
          detail: { expanded: isExpanded }
        }));
      }

      updateLayout() {
        window.requestAnimationFrame(() => {
          this.updateScrollable();
          this.updateReadMore();
        });
      }

      updateScrollable() {
        if (!this.track) return;

        const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
        this.track.classList.toggle('is-scrollable', isScrollable);
        if (isScrollable && !this.hasCenteredStart && this.hasAttribute('data-start-centered')) {
          this.hasCenteredStart = true;
          if (window.matchMedia('(min-width: 768px)').matches) {
            this.track.scrollLeft = (this.track.scrollWidth - this.track.clientWidth) / 2;
          }
        }
        if (this.controls) this.controls.hidden = !isScrollable;
        this.updateControls();
      }

      updateReadMore() {
        this.querySelectorAll('[data-review]').forEach((review) => {
          if (review.classList.contains('is-expanded')) return;

          const text = review.querySelector('[data-review-text]');
          const button = review.querySelector('[data-read-more]');
          if (!text || !button) return;

          button.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling && this.scrollbarPointerId == null) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }
    }

    customElements.define('customer-reviews', CustomerReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      // A pinned announcement bar covers the top of the screen: the header reaches it (and is covered) that much earlier.
      const stickyBar = document.querySelector('[data-announcement-sticky]');
      const stickyOffset = stickyBar ? stickyBar.getBoundingClientRect().height : 0;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom - stickyOffset;
      this.headerCoords.top = pageYOffset + clientRect.top - stickyOffset;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('icon-text-marquee')) return;

    class IconTextMarquee extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.update = this.update.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-icon-text-marquee-viewport]');
        this.groups = Array.from(this.querySelectorAll('[data-icon-text-marquee-group]'));

        if (!this.viewport || this.groups.length !== 2) return;

        if (!this.baseItems) {
          this.baseItems = Array.from(this.groups[1].children).map((item) => item.cloneNode(true));
        }

        if (!this.measureNode) {
          this.measureNode = document.createElement('div');
          this.measureNode.className = 'icon-text-marquee__measure';
          this.measureNode.setAttribute('aria-hidden', 'true');
          this.baseItems.forEach((item) => this.measureNode.appendChild(item.cloneNode(true)));
          this.viewport.appendChild(this.measureNode);
        }

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.switchTimer);
      }

      onResize() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(this.update);
      }

      get isOverflowing() {
        return this.classList.contains('icon-text-marquee--overflowing');
      }

      // Natural single-line width measured on a hidden nowrap copy, so the result never depends on the current mode.
      itemsOverflow() {
        const naturalWidth = this.measureNode.getBoundingClientRect().width;
        const availableWidth = this.getBoundingClientRect().width - 100;
        const hysteresis = this.isOverflowing ? 24 : 0;

        return naturalWidth > availableWidth - hysteresis;
      }

      update() {
        const wantsDesktopStatic = this.dataset.desktopStatic === 'true' && window.matchMedia('(min-width: 1025px)').matches;
        const overflowing = wantsDesktopStatic ? this.itemsOverflow() : false;
        const modeChanged = this.hasRendered && overflowing !== this.isOverflowing;

        const apply = () => {
          this.classList.toggle('icon-text-marquee--overflowing', overflowing);

          if (wantsDesktopStatic && !overflowing) {
            this.removeClones();
          } else {
            this.fillTrack();
          }
        };

        if (modeChanged) {
          clearTimeout(this.switchTimer);
          this.classList.add('icon-text-marquee--switching');
          this.switchTimer = setTimeout(() => {
            apply();
            this.classList.remove('icon-text-marquee--switching');
          }, 300);
        } else {
          apply();
        }

        this.hasRendered = true;
      }

      removeClones() {
        this.querySelectorAll('[data-icon-text-marquee-clone]').forEach((item) => item.remove());
      }

      fillTrack() {
        if (!this.baseItems?.length) return;

        this.classList.add('icon-text-marquee--measuring');

        let repetitions = 0;
        while (this.groups[0].scrollWidth < this.viewport.clientWidth && repetitions < 50) {
          this.groups.forEach((group, groupIndex) => {
            this.baseItems.forEach((item) => {
              const clone = item.cloneNode(true);
              clone.setAttribute('data-icon-text-marquee-clone', '');

              if (groupIndex === 0) {
                clone.setAttribute('aria-hidden', 'true');
              }

              group.appendChild(clone);
            });
          });
          repetitions += 1;
        }

        this.classList.remove('icon-text-marquee--measuring');
      }
    }

    customElements.define('icon-text-marquee', IconTextMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('image-with-list')) return;

    class ImageWithList extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.fitLabels = this.fitLabels.bind(this);
      }

      connectedCallback() {
        this.media = this.querySelector('[data-media]');
        this.labels = Array.from(this.querySelectorAll('[data-label]'));
        if (!this.media || !this.labels.length) return;
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.media);
        this.fitLabels();
        document.fonts?.ready.then(this.fitLabels);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.fitFrame);
      }

      onResize() {
        window.cancelAnimationFrame(this.fitFrame);
        this.fitFrame = window.requestAnimationFrame(this.fitLabels);
      }

      // Shrinks a label (font and em-based padding) so it fits between its left position and the image edge.
      fitLabels() {
        if (!this.isConnected || !this.media) return;
        const mediaWidth = this.media.clientWidth;
        this.labels.forEach((label) => {
          label.style.removeProperty('--image-with-list-label-fit');
          const available = mediaWidth - label.offsetLeft;
          const needed = label.offsetWidth;
          if (needed > 0 && available > 0 && needed > available) {
            label.style.setProperty('--image-with-list-label-fit', Math.max(0.4, Math.floor((available / needed) * 100) / 100).toFixed(2));
          }
        });
      }
    }

    customElements.define('image-with-list', ImageWithList);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ingredients-slider')) return;

    class IngredientsSlider extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onInteraction = this.onInteraction.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
      }

      connectedCallback() {
        this.hasInteracted = false;
        this.track = this.querySelector('[data-track]');
        this.controls = Array.from(this.querySelectorAll('[data-controls]'));
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.addEventListener('focusin', this.onInteraction);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.track?.addEventListener('wheel', this.onInteraction, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        window.addEventListener('pageshow', this.onPageShow);
        this.updateLayout();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.updateLayout();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeyDown);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.removeEventListener('focusin', this.onInteraction);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('wheel', this.onInteraction);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('pageshow', this.onPageShow);
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.activeScroller?.classList.remove('is-dragging');
        this.track?.classList.remove('is-scrollbar-dragging', 'is-free-scrolling', 'is-programmatic-scrolling');
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const toggleButton = event.target.closest('[data-toggle]');
        if (toggleButton && this.contains(toggleButton)) {
          this.toggleCard(toggleButton.closest('[data-card]'));
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollCards(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) this.scrollCards(1);
      }

      onKeyDown(event) {
        this.hasInteracted = true;
        if (event.key !== 'Escape') return;

        const openCard = event.target.closest('[data-card].is-open');
        if (!openCard || !this.contains(openCard)) return;

        this.toggleCard(openCard, false);
        openCard.querySelector('[data-toggle]')?.focus({ preventScroll: true });
      }

      onInteraction() {
        this.hasInteracted = true;
      }

      onPageShow() {
        this.updateLayout();
      }

      onResize() {
        this.updateLayout();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = this.getThumbWidth();
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX, true);
      }

      getThumbWidth() {
        return Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--ingredients-slider-scrollbar-thumb-width')
        ) || 0;
      }

      scrollToScrollbarPosition(clientX, animate = false) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = this.getThumbWidth();
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        if (animate) {
          this.animateScrollTo(maxScroll * progress, 400, true);
          return;
        }

        // Dragging: lock the track to the thumb instead of restarting the eased scroll on every move
        this.cancelScrollAnimation();
        this.scrollbar.value = String(progress * 100);
        this.track.scrollLeft = maxScroll * progress;
        this.updateControls();
      }

      scrollCards(direction) {
        if (!this.track) return;

        const cards = Array.from(this.track.querySelectorAll('[data-card]'));
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        this.hasInteracted = true;
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const scroller = event.target.closest('[data-scroll]');
        if (!scroller || !this.contains(scroller) || scroller.scrollWidth <= scroller.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activeScroller = scroller;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = scroller.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.activeScroller.setPointerCapture(event.pointerId);
          this.activeScroller.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.activeScroller.classList.add('is-dragging');
        this.activeScroller.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        if (this.activeScroller.hasPointerCapture(event.pointerId)) {
          this.activeScroller.releasePointerCapture(event.pointerId);
        }

        this.activeScroller.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activeScroller = null;
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      toggleCard(card, force) {
        if (!card) return;

        const isOpen = card.classList.toggle('is-open', force);
        card.querySelector('[data-toggle]')?.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          this.querySelectorAll('[data-card].is-open').forEach((otherCard) => {
            if (otherCard !== card) this.toggleCard(otherCard, false);
          });
        }

        this.dispatchEvent(new CustomEvent('ingredients-slider:toggle', {
          bubbles: true,
          detail: { card, open: isOpen }
        }));
      }

      updateLayout() {
        window.requestAnimationFrame(() => {
          this.updateScrollable();
        });
      }

      updateScrollable() {
        if (!this.track) return;

        const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
        this.track.classList.toggle('is-scrollable', isScrollable);
        this.controls?.forEach((controls) => {
          controls.hidden = !isScrollable;
        });
        if (!this.hasInteracted && this.track.scrollLeft > 0) this.resetScroll();
        this.updateControls();
      }

      // Safari can re-snap or restore the track to a later card while images, fonts and the layout settle:
      // keep the first card at the start until the visitor scrolls the slider themselves.
      resetScroll() {
        this.cancelScrollAnimation();
        this.track.classList.add('is-programmatic-scrolling');
        this.track.scrollLeft = 0;
        this.track.classList.remove('is-programmatic-scrolling');
      }

      updateControls() {
        if (!this.track) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (this.scrollbar && !this.isScrollbarScrolling && this.scrollbarPointerId == null) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }
    }

    customElements.define('ingredients-slider', IngredientsSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    if (customElements.get('collection-product-grid')) return;

    // Add to cart of the selected-products cards; the same request as sections/selected-products-tabs.liquid.
    class CollectionProductGrid extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const submitButton = event.target.closest('[data-submit]');
        if (submitButton && this.contains(submitButton)) this.addToCart(submitButton);
      }

      async addToCart(submitButton) {
        const addToCart = submitButton.closest('[data-selected-product]');
        const errorMessage = addToCart.querySelector('[data-form-error]');
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();

        formData.append('id', submitButton.dataset.variantId);
        formData.append('quantity', '1');
        if (submitButton.dataset.sellingPlanId) {
          formData.append('selling_plan', submitButton.dataset.sellingPlanId);
        }

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        errorMessage.hidden = true;

        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const responseText = await response.text();
          let result;

          try {
            result = JSON.parse(responseText);
          } catch (error) {
            throw new Error(window.cartStrings?.error || response.statusText);
          }

          if (!response.ok || result.status) throw new Error(result.description || result.message);

          if (cartDrawer?.renderContents) {
            cartDrawer.setActiveElement(submitButton);
            cartDrawer.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || `${window.Shopify.routes.root}cart`;
          }
        } catch (error) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }
    }

    customElements.define('collection-product-grid', CollectionProductGrid);

    if (!customElements.get('collection-description')) {
      class CollectionDescription extends HTMLElement {
        constructor() {
          super();
          this.expanded = false;
          this.onToggle = this.onToggle.bind(this);
          this.onResize = this.onResize.bind(this);
          this.measure = this.measure.bind(this);
        }

        connectedCallback() {
          this.content = this.querySelector('[data-content]');
          this.toggle = this.querySelector('[data-toggle]');
          this.label = this.querySelector('[data-toggle-label]');
          if (!this.content || !this.toggle || !this.label) return;
          this.toggle.addEventListener('click', this.onToggle);
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.content);
          this.measure();
          document.fonts?.ready.then(this.measure);
        }

        disconnectedCallback() {
          this.toggle?.removeEventListener('click', this.onToggle);
          this.resizeObserver?.disconnect();
          window.cancelAnimationFrame(this.measureFrame);
        }

        onResize() {
          window.cancelAnimationFrame(this.measureFrame);
          this.measureFrame = window.requestAnimationFrame(this.measure);
        }

        onToggle() {
          this.expanded = !this.expanded;
          this.classList.toggle('is-expanded', this.expanded);
          this.toggle.setAttribute('aria-expanded', String(this.expanded));
          this.label.textContent = this.expanded ? this.toggle.dataset.lessLabel : this.toggle.dataset.moreLabel;
          if (!this.expanded && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' });
        }

        // The button is shown only when the text is longer than the collapsed lines. Line clamping hides the
        // extra lines from scrollHeight, so the full height is read with the clamp briefly lifted (no repaint in between).
        measure() {
          if (!this.isConnected || this.expanded) return;
          this.classList.remove('is-fit');
          const collapsedHeight = this.content.getBoundingClientRect().height;
          this.classList.add('is-expanded');
          const fullHeight = this.content.getBoundingClientRect().height;
          this.classList.remove('is-expanded');
          const isClipped = fullHeight > collapsedHeight + 1;
          this.classList.toggle('is-fit', !isClipped);
          this.toggle.hidden = !isClipped;
        }
      }

      customElements.define('collection-description', CollectionDescription);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-comparison-add')) return;

    // Same request and cart drawer flow as the selected-products-tabs cards
    class ProductComparisonAdd extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const submitButton = event.target.closest('[data-submit]');
        if (submitButton && this.contains(submitButton) && !submitButton.disabled) this.addToCart(submitButton);
      }

      async addToCart(submitButton) {
        const errorMessage = this.querySelector('[data-form-error]');
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();

        formData.append('id', submitButton.dataset.variantId);
        formData.append('quantity', '1');
        if (submitButton.dataset.sellingPlanId) {
          formData.append('selling_plan', submitButton.dataset.sellingPlanId);
        }

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        errorMessage.hidden = true;

        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const responseText = await response.text();
          let result;

          try {
            result = JSON.parse(responseText);
          } catch (error) {
            throw new Error(window.cartStrings?.error || response.statusText);
          }

          if (!response.ok || result.status) throw new Error(result.description || result.message);

          this.dispatchEvent(new CustomEvent('product-comparison:added', {
            bubbles: true,
            detail: { product: result }
          }));

          if (cartDrawer?.renderContents) {
            cartDrawer.setActiveElement(submitButton);
            cartDrawer.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || `${window.Shopify.routes.root}cart`;
          }
        } catch (error) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
          this.dispatchEvent(new CustomEvent('product-comparison:error', {
            bubbles: true,
            detail: { message: error.message }
          }));
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }
    }

    customElements.define('product-comparison-add', ProductComparisonAdd);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-description')) return;

    const INLINE_GAP = 7;

    class ProductDescription extends HTMLElement {
      constructor() {
        super();
        this.expanded = false;
        this.onToggle = this.onToggle.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onFocusIn = this.onFocusIn.bind(this);
        this.measure = this.measure.bind(this);
      }

      connectedCallback() {
        this.content = this.querySelector('[data-content]');
        this.toggle = this.querySelector('[data-toggle]');
        this.label = this.querySelector('[data-toggle-label]');
        if (!this.content || !this.toggle || !this.label) return;
        this.toggle.addEventListener('click', this.onToggle);
        this.content.addEventListener('focusin', this.onFocusIn);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.content);
        this.measure();
        document.fonts?.ready.then(this.measure);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.content?.removeEventListener('focusin', this.onFocusIn);
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.measureFrame);
      }

      onResize() {
        window.cancelAnimationFrame(this.measureFrame);
        this.measureFrame = window.requestAnimationFrame(this.measure);
      }

      onToggle() {
        this.setExpanded(!this.expanded);
        if (!this.expanded && this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' });
      }

      // A link inside the clipped part must not receive focus while it is invisible.
      onFocusIn(event) {
        if (this.expanded || this.toggle.hidden) return;
        const isBelow = event.target.getBoundingClientRect().bottom > this.content.getBoundingClientRect().bottom + 1;
        if (!isBelow && this.content.scrollTop === 0) return;
        this.content.scrollTop = 0;
        this.setExpanded(true);
      }

      setExpanded(expanded) {
        this.expanded = expanded;
        this.classList.toggle('product-description--expanded', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
        this.label.textContent = expanded ? this.toggle.dataset.lessLabel : this.toggle.dataset.moreLabel;
        if (!expanded) this.measure();
      }

      // Finds the last visible line of text and puts the button on it: right after the text when there is room, over its end otherwise.
      measure() {
        if (!this.isConnected || !this.content || this.expanded) return;
        this.fitFirstParagraph();
        const box = this.content.getBoundingClientRect();
        const { line, hasHiddenText } = this.readLines(box);
        const hasHiddenMedia = Array.from(this.content.querySelectorAll('img, video, iframe, table')).some(
          (media) => media.getBoundingClientRect().bottom > box.bottom + 1
        );
        // Trailing empty lines alone are not worth a button.
        const isClipped = this.content.scrollHeight > this.content.clientHeight + 1 && (hasHiddenText || hasHiddenMedia);
        this.toggle.hidden = !isClipped;
        if (!isClipped) return;

        // Without a visible line of text (media first) the button takes the bottom right corner.
        const top = line ? (line.top + line.bottom) / 2 - this.toggle.offsetHeight / 2 - box.top : box.height - this.toggle.offsetHeight;
        const left = line ? line.right - box.left + INLINE_GAP : box.width;
        const isInline = left + this.label.offsetWidth <= box.width;
        this.classList.toggle('product-description--toggle-inline', isInline);
        this.style.setProperty('--product-description-toggle-top', `${Math.round(top)}px`);
        this.style.setProperty('--product-description-toggle-left', `${Math.round(left)}px`);
      }

      // With the first paragraph option, the collapsed text ends with the first paragraph when it is longer than the
      // set lines but at most twice as long. The paragraph keeps its height when clipped, so this never loops.
      fitFirstParagraph() {
        if (!this.hasAttribute('data-first-paragraph')) return;
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        const lines = parseFloat(
          getComputedStyle(this).getPropertyValue(
            isDesktop ? '--product-description-lines' : '--product-description-mobile-lines'
          )
        );
        const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight);
        const first = this.content.firstElementChild;
        const height = first ? first.getBoundingClientRect().height : 0;
        const base = lines * lineHeight;
        if (base > 0 && height > base + 1 && height <= base * 2 + 1) {
          this.style.setProperty('--product-description-clamp', `${Math.round(height)}px`);
        } else {
          this.style.removeProperty('--product-description-clamp');
        }
      }

      // Returns the last line of text inside the box and whether any text continues below it.
      readLines(box) {
        const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT);
        const range = document.createRange();
        let line = null;
        while (walker.nextNode()) {
          if (!walker.currentNode.textContent.trim()) continue;
          range.selectNodeContents(walker.currentNode);
          for (const rect of range.getClientRects()) {
            if (!rect.width) continue;
            if (rect.bottom > box.bottom + 1) return { line, hasHiddenText: true };
            if (!line || rect.top > line.top + rect.height / 2) {
              line = { top: rect.top, bottom: rect.bottom, right: rect.right };
            } else {
              line.right = Math.max(line.right, rect.right);
            }
          }
        }
        return { line, hasHiddenText: false };
      }
    }

    customElements.define('product-description', ProductDescription);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-products-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('selected-products-tabs')) return;

    class SelectedProductsTabs extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onScrollbarInput = this.onScrollbarInput.bind(this);
        this.onScrollbarPointerDown = this.onScrollbarPointerDown.bind(this);
      }

      connectedCallback() {
        this.isSplit = this.dataset.layout === 'split';
        this.track = this.querySelector('[data-track]');
        this.tabs = this.querySelector('[data-tabs]');
        this.tabsHeader = this.querySelector('[data-tabs-header]');
        this.tabsHeading = this.querySelector('[data-tabs-heading]');
        this.controls = this.querySelector('[data-controls]');
        this.scrollbar = this.querySelector('[data-scrollbar]');
        this.previousButton = this.querySelector('[data-scroll-previous]');
        this.nextButton = this.querySelector('[data-scroll-next]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('pointerdown', this.onPointerDown);
        this.addEventListener('dragstart', this.onDragStart);
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scrollbar?.addEventListener('input', this.onScrollbarInput);
        this.scrollbar?.addEventListener('pointerdown', this.onScrollbarPointerDown);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
        window.addEventListener('resize', this.onResize);
        this.tabsResizeObserver = new ResizeObserver(this.onResize);
        if (this.tabsHeader) this.tabsResizeObserver.observe(this.tabsHeader);
        this.updateScrollable();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('dragstart', this.onDragStart);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.scrollbar?.removeEventListener('input', this.onScrollbarInput);
        this.scrollbar?.removeEventListener('pointerdown', this.onScrollbarPointerDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
        window.removeEventListener('resize', this.onResize);
        this.tabsResizeObserver?.disconnect();
        window.clearTimeout(this.clickResetTimer);
        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.activeScroller?.classList.remove('is-dragging');
        this.track?.classList.remove('is-scrollbar-dragging', 'is-free-scrolling', 'is-programmatic-scrolling');
      }

      onClick(event) {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
          return;
        }

        const submitButton = event.target.closest('[data-submit]');
        if (submitButton && this.contains(submitButton)) {
          this.addToCart(submitButton);
          return;
        }

        const previousButton = event.target.closest('[data-scroll-previous]');
        if (previousButton && this.contains(previousButton)) {
          this.scrollProducts(-1);
          return;
        }

        const nextButton = event.target.closest('[data-scroll-next]');
        if (nextButton && this.contains(nextButton)) {
          this.scrollProducts(1);
          return;
        }

        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) {
          this.selectTab(tab);
          return;
        }
      }

      selectTab(selectedTab) {
        const filter = selectedTab.dataset.filter;

        this.querySelectorAll('[data-tab]').forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', String(isSelected));
        });

        this.querySelectorAll('[data-card]').forEach((card) => {
          const tags = card.dataset.tags.split(/\s+/).filter(Boolean);
          card.hidden = filter !== 'all' && !tags.includes(filter);
        });

        if (this.track) this.track.scrollLeft = 0;
        this.updateScrollable();
      }

      async addToCart(submitButton) {
        const addToCart = submitButton.closest('[data-selected-product]');
        const errorMessage = addToCart.querySelector('[data-form-error]');
        const cartDrawer = document.querySelector('cart-drawer');
        const formData = new FormData();

        formData.append('id', submitButton.dataset.variantId);
        formData.append('quantity', '1');
        if (submitButton.dataset.sellingPlanId) {
          formData.append('selling_plan', submitButton.dataset.sellingPlanId);
        }

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        errorMessage.hidden = true;

        if (cartDrawer?.getSectionsToRender) {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        try {
          const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const responseText = await response.text();
          let result;

          try {
            result = JSON.parse(responseText);
          } catch (error) {
            throw new Error(window.cartStrings?.error || response.statusText);
          }

          if (!response.ok || result.status) throw new Error(result.description || result.message);

          this.dispatchEvent(new CustomEvent('selected-products:added', {
            bubbles: true,
            detail: { product: result }
          }));

          if (cartDrawer?.renderContents) {
            cartDrawer.setActiveElement(submitButton);
            cartDrawer.renderContents(result);
          } else {
            window.location.href = window.routes?.cart_url || `${window.Shopify.routes.root}cart`;
          }
        } catch (error) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
          this.dispatchEvent(new CustomEvent('selected-products:error', {
            bubbles: true,
            detail: { message: error.message }
          }));
        } finally {
          submitButton.disabled = false;
          submitButton.classList.remove('is-loading');
        }
      }

      onResize() {
        this.updateScrollable();
      }

      onScroll() {
        this.updateControls();
      }

      onScrollbarInput() {
        if (!this.track || !this.scrollbar) return;

        this.track.classList.add('is-free-scrolling');
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = maxScroll * (Number(this.scrollbar.value) / 100);
        this.animateScrollTo(targetLeft, 400, true);
      }

      onScrollbarPointerDown(event) {
        if (event.button !== 0 || !this.scrollbar) return;

        event.preventDefault();
        this.scrollbarPointerId = event.pointerId;
        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--selected-products-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const thumbCenter = scrollbarRect.left + thumbWidth / 2
          + availableWidth * (Number(this.scrollbar.value) / 100);
        this.scrollbarGrabOffset = Math.abs(event.clientX - thumbCenter) <= thumbWidth / 2
          ? event.clientX - thumbCenter
          : 0;

        this.scrollbar.focus({ preventScroll: true });
        this.scrollbar.setPointerCapture(event.pointerId);
        this.track?.classList.add('is-scrollbar-dragging');
        this.scrollToScrollbarPosition(event.clientX, true);
      }

      scrollToScrollbarPosition(clientX, animate = false) {
        if (!this.track || !this.scrollbar) return;

        const scrollbarRect = this.scrollbar.getBoundingClientRect();
        const thumbWidth = Number.parseFloat(
          window.getComputedStyle(this.scrollbar).getPropertyValue('--selected-products-scrollbar-thumb-width')
        ) || 0;
        const availableWidth = Math.max(scrollbarRect.width - thumbWidth, 0);
        const pointerPosition = clientX - (this.scrollbarGrabOffset || 0) - scrollbarRect.left - thumbWidth / 2;
        const progress = availableWidth > 0
          ? Math.max(0, Math.min(pointerPosition / availableWidth, 1))
          : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        this.track.classList.add('is-free-scrolling');
        if (animate) {
          this.animateScrollTo(maxScroll * progress, 400, true);
          return;
        }

        // Dragging: lock the track to the thumb instead of restarting the eased scroll on every move
        this.cancelScrollAnimation();
        this.scrollbar.value = String(progress * 100);
        this.track.scrollLeft = maxScroll * progress;
        this.updateControls();
      }

      scrollProducts(direction) {
        if (!this.track) return;

        const cards = Array.from(this.track.querySelectorAll('[data-card]:not([hidden])'));
        if (!cards.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        const firstCardOffset = this.track.scrollLeft + cards[0].getBoundingClientRect().left - trackLeft;
        const cardOffsets = cards.map((card) => (
          this.track.scrollLeft + card.getBoundingClientRect().left - trackLeft - firstCardOffset
        ));
        const cardStep = cardOffsets.length > 1 ? Math.abs(cardOffsets[1] - cardOffsets[0]) : 0;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const remainingScroll = maxScroll - this.track.scrollLeft;

        if (direction > 0 && remainingScroll > 1 && remainingScroll < cardStep * 2) {
          const duration = Math.max(700, 700 * (remainingScroll / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(maxScroll, duration);
          return;
        }

        if (direction < 0 && this.track.scrollLeft > 1 && this.track.scrollLeft < cardStep * 2) {
          const duration = Math.max(700, 700 * (this.track.scrollLeft / cardStep));
          this.track.classList.remove('is-free-scrolling');
          this.animateScrollTo(0, duration);
          return;
        }

        const currentIndex = cardOffsets.reduce((closestIndex, offset, index) => (
          Math.abs(offset - this.track.scrollLeft) < Math.abs(cardOffsets[closestIndex] - this.track.scrollLeft)
            ? index
            : closestIndex
        ), 0);
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, cards.length - 1));

        this.track.classList.remove('is-free-scrolling');
        this.animateScrollTo(cardOffsets[targetIndex]);
      }

      animateScrollTo(targetLeft, duration = 700, isScrollbarScrolling = false) {
        this.cancelScrollAnimation();

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const startLeft = this.track.scrollLeft;
        const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
        const distance = endLeft - startLeft;
        const startTime = performance.now();

        this.isScrollbarScrolling = isScrollbarScrolling;
        if (Math.abs(distance) < 1) {
          this.isScrollbarScrolling = false;
          this.updateControls();
          return;
        }

        this.track.classList.add('is-programmatic-scrolling');
        const animate = (currentTime) => {
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const easedProgress = isScrollbarScrolling
            ? 1 - Math.pow(1 - progress, 3)
            : progress < 0.5
              ? 4 * progress * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 3) / 2;

          this.track.scrollLeft = startLeft + distance * easedProgress;
          if (isScrollbarScrolling && this.scrollbar) {
            this.scrollbar.value = maxScroll > 0
              ? String((this.track.scrollLeft / maxScroll) * 100)
              : '0';
          }

          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
            return;
          }

          this.scrollAnimationFrame = null;
          this.isScrollbarScrolling = false;
          this.track.classList.remove('is-programmatic-scrolling');
          this.updateControls();
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      }

      cancelScrollAnimation() {
        if (!this.scrollAnimationFrame) return;

        window.cancelAnimationFrame(this.scrollAnimationFrame);
        this.scrollAnimationFrame = null;
        this.isScrollbarScrolling = false;
        this.track?.classList.remove('is-programmatic-scrolling');
      }

      onPointerDown(event) {
        if (event.button !== 0 || event.pointerType === 'touch') return;

        const scroller = event.target.closest('[data-scroll]');
        if (!scroller || !this.contains(scroller) || scroller.scrollWidth <= scroller.clientWidth + 1) return;

        this.cancelScrollAnimation();
        this.activeScroller = scroller;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = scroller.scrollLeft;
        this.activePointerId = event.pointerId;
        this.hasDragged = false;
      }

      onPointerMove(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          this.scrollToScrollbarPosition(event.clientX);
          event.preventDefault();
          return;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.hasDragged && Math.abs(distance) < 5) return;

        if (!this.hasDragged) {
          this.activeScroller.setPointerCapture(event.pointerId);
          if (this.activeScroller === this.track) this.activeScroller.classList.remove('is-free-scrolling');
        }
        this.hasDragged = true;
        this.activeScroller.classList.add('is-dragging');
        this.activeScroller.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        if (event.pointerId === this.scrollbarPointerId) {
          if (this.scrollbar?.hasPointerCapture(event.pointerId)) {
            this.scrollbar.releasePointerCapture(event.pointerId);
          }
          this.track?.classList.remove('is-scrollbar-dragging');
          this.scrollbarPointerId = null;
          this.scrollbarGrabOffset = 0;
        }

        if (!this.activeScroller || event.pointerId !== this.activePointerId) return;

        if (this.activeScroller.hasPointerCapture(event.pointerId)) {
          this.activeScroller.releasePointerCapture(event.pointerId);
        }

        this.activeScroller.classList.remove('is-dragging');
        this.suppressClick = this.hasDragged && event.type === 'pointerup';
        if (this.suppressClick) {
          window.clearTimeout(this.clickResetTimer);
          this.clickResetTimer = window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }
        this.activeScroller = null;
        this.activePointerId = null;
        this.hasDragged = false;
      }

      onDragStart(event) {
        if (event.target.closest('[data-scroll]')) event.preventDefault();
      }

      updateScrollable() {
        if (!this.track) return;

        window.requestAnimationFrame(() => {
          this.updateTabsScrollable();
          const isScrollable = this.track.scrollWidth > this.track.clientWidth + 1;
          this.track.classList.toggle('is-scrollable', isScrollable);
          if (this.controls) this.controls.hidden = !isScrollable;
          this.updateControls();
        });
      }

      updateTabsScrollable() {
        if (!this.tabs || !this.tabsHeader || !this.tabsHeading) return;

        if (!window.matchMedia('(min-width: 768px)').matches) {
          this.tabs.classList.remove('is-scrollable');
          this.tabsHeader.classList.remove('is-tabs-below');
          return;
        }

        const tabs = Array.from(this.tabs.querySelectorAll('[data-tab]'));
        const gap = Number.parseFloat(window.getComputedStyle(this.tabs).columnGap) || 0;
        const contentWidth = tabs.reduce((width, tab) => width + tab.getBoundingClientRect().width, 0)
          + Math.max(0, tabs.length - 1) * gap;
        const headerGap = Number.parseFloat(window.getComputedStyle(this.tabsHeader).columnGap) || 0;
        const headerWidth = this.tabsHeader.getBoundingClientRect().width;
        const inlineAvailableWidth = headerWidth - this.tabsHeading.getBoundingClientRect().width - headerGap;
        const isBelow = this.isSplit || contentWidth > inlineAvailableWidth + 1;
        const availableWidth = isBelow ? headerWidth : inlineAvailableWidth;
        const isScrollable = contentWidth > availableWidth + 1;

        this.tabsHeader.classList.toggle('is-tabs-below', isBelow);
        this.tabs.classList.toggle('is-scrollable', isScrollable);
        if (!isScrollable) this.tabs.scrollLeft = 0;
      }

      updateControls() {
        if (!this.track || !this.scrollbar) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const scrollPosition = Math.max(0, Math.min(this.track.scrollLeft, maxScroll));
        if (!this.isScrollbarScrolling && this.scrollbarPointerId == null) {
          this.scrollbar.value = maxScroll > 0 ? String((scrollPosition / maxScroll) * 100) : '0';
        }
        if (this.previousButton) this.previousButton.disabled = scrollPosition <= 1;
        if (this.nextButton) this.nextButton.disabled = scrollPosition >= maxScroll - 1;
      }

    }

    customElements.define('selected-products-tabs', SelectedProductsTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
